import Layout from "../../components/Layout/Layout"
import MainLayoutLoader from "../../components/LayoutLoaders/MainLayoutLoader"
import { Outlet, useParams } from "react-router-dom"
import { useAppSelector } from "../../hooks"
import { selectMainSlice } from "../../redux/slice/main"

export default function ProjectPageWrap() {
  const { category_id } = useParams()
  const { projects } = useAppSelector(selectMainSlice)

  return (
    <Layout isHeaderMobHidden={!(projects?.length === 1 && !category_id)} mainLoader={<MainLayoutLoader />}>
      <Outlet />
    </Layout>
  )
}
